module.exports = __webpack_public_path__ + "51b008642119795c819fc9669d03dc68.png";